import BookingMemberToEventPriceDefinition from './BookingMemberToEventPriceDefinition'
import BookingMemberToEventAdditionalPriceDefinition from './BookingMemberToEventAdditionalPriceDefinition'

export default class BookingMembers {
    id: number
    bookingId: number
    tblBookingMemberToEventPriceDefinition: BookingMemberToEventPriceDefinition[] = new Array<BookingMemberToEventPriceDefinition>()
    tblBookingMemberToEventAdditionalPriceDefinition: BookingMemberToEventAdditionalPriceDefinition[] = new Array<BookingMemberToEventAdditionalPriceDefinition>()
    firstName: string = ''
    lastName: string = ''
    gender: number
    phone: string
    birthday: Date = null
    note: string
    teamId: number
    overallPrice: number = 0
    eventOptionId: number
    memberAgeGroupId: number
    memberAgeGroupName: string
    memberGroupTypeId: number
    teamLeader: boolean
    [key: string]: any
}